import React from 'react'

function JackpotGral(props) {
  return (
    <div className='contJacpot'>
      <div className='gridJacpot'>
        <div className='textJack'>Jackpot</div>
        <div className='textTipo'>
          <spam className='textGeral'>General</spam>
          </div>
        <div className='textMonto'>$ {props.value}</div>
        <div className='textTicket'>Ticket: {props.ticket}</div>
      </div>
    </div>
  )
}

export default JackpotGral